import React, { useEffect } from 'react';
import DemoNavbar from './components/DemoNavbar';
import DemoHero from './components/DemoHero';
import DemoVideoSection from './components/DemoVideoSection';
import DemoLifecycle from './components/DemoLifecycle';
import ModuleExplorer from './components/ModuleExplorer';
import InteractiveSandbox from './components/InteractiveSandbox';
import DemoFooter from './components/DemoFooter';
import './ERPDemoPage.css';

const ERPDemoPage = () => {
  useEffect(() => {
    // Set dynamic page title
    document.title = 'Prophecy Nexus - Interactive Demo & Enterprise Suite';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="erp-demo-wrapper">
      <DemoNavbar />
      <main>
        <DemoHero />
        <DemoVideoSection videoSrc={`${process.env.PUBLIC_URL || ''}/videos/demo_video_prophecy.mp4`} />
        <DemoLifecycle />
        <ModuleExplorer />
        <InteractiveSandbox />
      </main>
      <DemoFooter />
    </div>
  );
};

export default ERPDemoPage;
